import { config } from '@skytech/config'

export const FORM_URL = `${config.FORM_URL}/:code`
